import React, { Component } from "react";

import { withRouter, Switch, Route, Redirect } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";

import Products from "./products/Products";
import Product from "./products/Product";
import Unavailabilities from "./unavailabilities/Unavailabilities";
import Unavailability from "./unavailabilities/Unavailability";
import Categories from "./categories/Categories";
import Category from "./categories/Category";
import Periods from "./periods/Periods";
import Period from "./periods/Period";
import Grid from "./grid/Grid";
import Price from "./grid/Price";
import SalesInformations from "./sales-informations/SalesInformations";
import SalesInformation from "./sales-informations/SalesInformation";
import Informations from "./informations/Informations";
import FindInPageIcon from "@material-ui/icons/FindInPage";

import { authenticated } from "../services/auth";
import { withConfiguration } from "../services/config";

import "./Nav.css";

const routes = [
  { path: "/products/:id", component: Product },
  { path: "/products", component: Products },
  { path: "/periods/:id", component: Period },
  { path: "/periods", component: Periods },
  { path: "/price-grid/:id", component: Price },
  { path: "/price-grid", component: Grid },
  { path: "/unavailabilities/:id", component: Unavailability },
  { path: "/unavailabilities", component: Unavailabilities },
  { path: "/categories/:id", component: Category },
  { path: "/categories", component: Categories },
  { path: "/sales-informations/:id", component: SalesInformation },
  { path: "/sales-informations", component: SalesInformations },
  { path: "/informations", component: Informations }
];
const tabs = [
  { path: "/price-grid", label: "Grille de prix" },
  { path: "/unavailabilities", label: "Indisponibilités" },
  { path: "/products", label: "Produits" },
  { path: "/periods", label: "Période de prix" },
  { path: "/categories", label: "Catégories" },
  { path: "/sales-informations", label: "Listes de Valeurs" },
  { path: "/informations", label: "Informations marchand" },
  { path: "/preview" }
];

const TabContainer = ({ children }) => {
  return (
    <Typography component="div" style={{ padding: 12 }}>
      {children}
    </Typography>
  );
};

class Nav extends Component {
  state = {};
  async componentDidMount() {
    const auth = authenticated();

    this.setState({
      resortslug: auth.currentMerchant.resortslug,
      merchantslug: auth.currentMerchant.merchantslug
    });
  }
  handleChange = (e, value) => {
    if (value === "/preview") {
      const { resortslug, merchantslug } = this.state;
      window.open(
        `${withConfiguration(
          config => config.msem.api
        )}/station/${resortslug}/location-de-materiel/${merchantslug}?preview=true`,
        "_blank"
      );
    } else {
      this.setState({ value }, () => this.props.history.push(value));
    }
  };

  renderTabs() {
    return tabs.map(tab => this.renderTab(tab));
  }
  renderTab({ path, label }) {
    const { init } = this.props;
    return (
      <Tab
        key={path}
        value={path}
        label={label}
        icon={path === "/preview" && <FindInPageIcon />}
        disabled={init && path !== "/informations"}
      />
    );
  }

  renderRoutes() {
    return routes.map(route => this.renderRoute(route));
  }
  renderRoute({ path, component }) {
    const Screen = component;
    return <Route exact key={path} path={path} component={Screen} />;
  }

  renderError() {
    return (
      <div className="sp-nav--servererror">Erreur de connexion au serveur</div>
    );
  }
  render() {
    const { location, init } = this.props;
    const scrollableNav = window.innerWidth < 800;
    const pathname = location.pathname.split("/");
    const initialTab =
      pathname.length >= 2 && pathname[1] !== ""
        ? `/${pathname[1]}`
        : init
          ? "/informations"
          : "/products";

    return (
      <div>
        <AppBar position="static">
          <Tabs
            value={this.state.value || initialTab}
            onChange={this.handleChange}
            centered={!scrollableNav}
            fullWidth={!scrollableNav}
            scrollable={scrollableNav}
            scrollButtons="auto"
          >
            {this.renderTabs()}
          </Tabs>
        </AppBar>
        <TabContainer>
          {authenticated() !== undefined ? (
            <Switch location={location}>
              <Route
                exact
                key="index"
                path="/"
                render={() =>
                  init ? (
                    <Redirect to="/informations" />
                  ) : (
                    <Redirect to="/products" />
                  )
                }
              />
              {this.renderRoutes()}
            </Switch>
          ) : (
            this.renderError()
          )}
        </TabContainer>
      </div>
    );
  }
}

export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav.js